import request from '@/utils/request'

// 获取图形验证码
export function getCaptcha() {
    return request({
        url: '/api/auth/captcha',
        method: 'get'
    })
}

// 登录
export function login(data) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data
    })
}

// 获取当前登录用户信息
export function getCurrentUser() {
    return request({
        url: '/api/auth/me',
        method: 'get'
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/api/auth/logout',
        method: 'post'
    })
}

export function refreshToken() {
    return request({
        url: '/api/auth/refresh',
        method: 'post'
    })
}